<template>
    <div>
        <img class="example-headImg" src="../assets/image/selected/08-4banner.png"/>
        <div class="head-explain">
            <img class="head-img-logo" src="../assets/image/selected/08-4IDMS.png" style="width:9.6rem;height: 4.8rem;"/>
            <div class="head-explain-title">市场准入与商务运营</div>
            <div class="head-explain-content">IQVIA iDMS 面向医药和器械行业市场准入</div>
            <div class="head-explain-content" style="margin-top:-3rem">与商务运营管理</div>
        </div>
        <div class="container-1">
            <div class="saled-box1">
                <div class="title1">
                    IQVIA iDMS 面向医药和器械行业市场准入与商务运营管理，全面覆盖招投标、经销商招募、经销商运营、渠道回款与经销商返利管理。<br/>
                    完整对应了商务团队的各项职能，实现前瞻性高效性的商务决策与运营。
                </div>
            </div>
        </div>
        <div class="container-2" style="height:90rem">
            <div class="saled-box2">
                <div class="container">
                    <div class="card">
                        <img src="../assets/image/selected/08-4一站式.png"/>
                        <div class="title" style="margin-top:2.5rem">一站式操作</div>
                    </div>
                    <div class="card">
                        <img src="../assets/image/selected/08-4实时业务.png"/>
                        <div class="title" style="margin-top:2.5rem">实时业务洞察</div>
                    </div>
                    <div class="card">
                        <img src="../assets/image/selected/08-4加速业务.png"/>
                        <div class="title" style="margin-top:2.5rem">加速业务流程</div>
                    </div>
                </div>
                <img class="saled-box2-img" src="../assets/image/selected/08-4中图.png"/>
            </div>
        </div>

    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'BizfocusPagesPurchaseCollaboration',
    metaInfo:{
        meta:[
        { name:'keywords', content:'市场准入与商务运营,一站式操作,实时业务洞察,加速业务流程' },
        { name:'description', content:'IQVIA iCRM IQVIA iDMS 面向医药和器械行业市场准入与商务运营管理，全面覆盖招投标、经销商招募、经销商运营、渠道回款与经销商返利管理。完整对应了商务团队的各项职能，实现前瞻性高效性的商务决策与运营。' }
        ]
    },
    data() {
        return {
        };
    },

    mounted() {
        this.activeIndex = '2'
        this.newsIndex = false
        this.refreshIndexInfo({
            data:this.activeIndex ,
            news:this.newsIndex
        });
    },

    methods: {
        ...mapActions([
            'refreshIndexInfo'
        ]),
    },
};
</script>

<style lang="less" scoped>
.saled-box1{
    width: 139.7rem;
    height: 8.8rem;
    margin: auto;
    margin-top: 4.4rem;
    margin-bottom: 2rem;
    .title1{
        width: 139.7rem;
        height: 8.8rem;
        font-size: 1.6rem;
        font-family: 'CN_Normal';
        font-weight: 400;
        color: #333333;
        line-height: 3rem;
        margin-top: 2rem;
        
    }
}
.saled-box2{
    width: 86rem;
    margin: auto;
    .container{
        width: 86rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .card{
            width: 26rem;
            display: flex;
            margin-top: 5rem;
            margin-bottom: 5.6rem;
            img{
                width: 7rem;
                height: 7rem;
                float: left;
            }
            .title{
                margin-left: 2.1rem;
                width: 18rem;
                font-size: 1.4rem;
                font-family: 'CN_Normal';
                text-align: justify;
                margin-top: 1.5rem;
                font-weight: 400;
                color: #666666;
                line-height: 2rem;
            }
        }
    }
    .saled-box2-img{
        width: 86.4rem;
        height: 55.8rem;
    }
}
</style>
